import { FeatureStatusChangedMessage, GameUIMessageType } from 'game-ui-types'
import { useConfigurationStore } from '@stores'
import useMessageData from './useMessage'

const useFeatureLayout = () => {
    const setIsFeatureRunning = useConfigurationStore((state) => state.setIsFeatureRunning)

    useMessageData(
        (data) => {
            if (data?.type !== GameUIMessageType.FEATURE_STATUS_CHANGED) return

            const { status } = (data as FeatureStatusChangedMessage).payload

            if (status === 'started') setIsFeatureRunning(true)

            if (status === 'completed') setIsFeatureRunning(false)
        },
        [setIsFeatureRunning]
    )
}

export default useFeatureLayout
